export default {"src":"/_next/static/media/1.d2979a96.svg","height":82,"width":76,"blurWidth":0,"blurHeight":0};